import TriggersTemplatePages from './TriggersTemplatePages';

export default TriggersTemplatePages;